
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Downloads } from '../components/downloads';
import { GetStaticProps, NextPage } from 'next/types';
import Image from 'next/image';
import { NextSeo } from 'next-seo';
import { PAGE } from '../consts/PAGES';
import { getAdvertisePageById } from '../utils/getPage';
import useTranslation from 'next-translate/useTranslation';
import { Downloads2 } from '@components/download2';
interface IPage {
    page: {
        title: string;
        advertise: {
            pvc: {
                catalogs: {
                    name: string;
                    icon: {
                        sourceUrl: string;
                    };
                    file: {
                        mediaItemUrl: string;
                    };
                }[];
                flyers: [
                ];
            };
            alu: {
                catalogs: [
                ];
                flyers: [
                ];
            };
        };
        downloads: {
            downloads: {
                name: string;
                icon: {
                    sourceUrl: string;
                };
                file: {
                    mediaItemUrl: string;
                };
            }[];
        };
    };
}
const AdvertisingMaterials: NextPage<IPage> = ({ page }) => {
    const { t } = useTranslation('common');
    return (<>
      <NextSeo languageAlternates={[
            {
                hrefLang: 'x-default',
                href: 'https://knsokna.pl/advertising-materials',
            },
            {
                hrefLang: 'en',
                href: 'https://knswindows.com/advertising-materials',
            },
            { hrefLang: 'pl', href: 'https://knsokna.pl/advertising-materials' },
            {
                hrefLang: 'de',
                href: 'https://knsfenster.de/advertising-materials',
            },
            { hrefLang: 'cs', href: 'https://kns-okna.eu/advertising-materials' },
            {
                hrefLang: 'it',
                href: 'https://knsfinestre.it/advertising-materials',
            },
            {
                hrefLang: 'fr',
                href: 'https://knsfenetres.fr/advertising-materials',
            },
            { hrefLang: 'hu', href: 'https://knsokna.eu/advertising-materials' },
        ]}/>
      <div className="bg-white">
        <div className="max-w-7xl mx-auto">
          <Image src="/img/advertise.webp" alt="advertise" width="1600" height="599"/>
        </div>
        <div className="max-w-7xl mx-auto py-2 px-2 xl:px-0">
          <div className="text-center py-3">
            <span className="text-lg py-1 px-3 bg-gradient-to-r from-red to-orange text-white font-bold uppercase">
              {t('products.pvc')}
            </span>
          </div>
          <div className="bg-gray-100 text-sm p-2">KATALOGI</div>
          <Downloads2 downloads={page?.advertise.pvc.catalogs}/>
          <div className="bg-gray-100 text-sm p-2">ULOTKI</div>
          <Downloads2 downloads={page?.advertise.pvc.flyers}/>
        </div>
        <div className="max-w-7xl mx-auto py-2 px-2 xl:px-0">
          <div className="text-center py-3">
            <span className="text-lg py-1 px-3 bg-gradient-to-r from-red to-orange text-white font-bold uppercase">
              {t('products.alu')} | {t('products.rollers')}
            </span>
          </div>
          <div className="bg-gray-100 text-sm p-2">KATALOGI</div>
          <Downloads2 downloads={page?.advertise.alu.catalogs}/>
          <div className="bg-gray-100 text-sm p-2">ULOTKI</div>
          <Downloads2 downloads={page?.advertise.alu.flyers}/>
        </div>
      </div>
    </>);
};
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale || 'PL';
    const LOCALE = locale === 'cz' ? 'CS' : locale.toUpperCase();
    const PAGE_ID = PAGE.ADVERTISE_MATERIALS[LOCALE as keyof typeof PAGE.ADVERTISE_MATERIALS] ||
        1;
    const { page } = await getAdvertisePageById(PAGE_ID);
    return {
        props: {
            page,
        },
    };
};
export default AdvertisingMaterials;

    async function __Next_Translate__getStaticProps__196386c50c7__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/advertising-materials',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196386c50c7__ as getStaticProps }
  